var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightRadiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116,
    height: 287,
    viewBox: "0 0 116 287",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3952 286.207C101.503 251.512 137.208 193.155 101.066 147.282C85.2591 127.218 59.9751 112.162 39.0447 94.9445C27.6908 85.6036 16.6267 75.381 11.4725 63.4181C3.40978 44.7092 13.1168 27.9762 27.3328 12.24C29.724 9.59295 27.7824 -3.2469 22.6819 1.04979C2.19638 18.311 -3.45815 43.9111 3.41423 65.3176C10.3881 87.039 31.8787 103.695 52.9503 119.336C79.814 139.273 108.606 159.348 108.196 189.039C107.719 223.441 78.2784 252.027 51.059 278.828C49.5446 280.32 51.1365 287.837 53.3952 286.207Z",
    fill: "#7064E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightRadiant);
export default __webpack_public_path__ + "static/media/RightRadiant.815cbc0a861c0d4ed6fe499871c28db3.svg";
export { ForwardRef as ReactComponent };